export const unloadMentionMe = () => {
  if (typeof document !== 'undefined') {
    const elem = document.getElementById('waldo-mentionme-script');
    if (elem) {
      elem.parentNode?.removeChild(elem);
    }
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof window !== 'undefined' && window['MentionMe']) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete window['MentionMe'];
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof window !== 'undefined' && window['MentionMeFiredTags']) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete window['MentionMeFiredTags'];
  }
};
